import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fe-typ',
    templateUrl: './typ.component.html',
    styleUrls: ['./typ.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TypPageComponent {}
